export default "__VITE_ASSET__DmlhaoZG__"